<script setup>
import { computed } from 'vue'

const props = defineProps({ tone: { type: String, default: 'info' }, icon: { type: String, default: '' } })
const tones = {
  info: ['border-blue-200 bg-blue-50 text-blue-900 dark:border-blue-900 dark:bg-blue-950/40 dark:text-blue-100', 'fa-circle-info'],
  warning: ['border-amber-200 bg-amber-50 text-amber-900 dark:border-amber-900 dark:bg-amber-950/40 dark:text-amber-100', 'fa-triangle-exclamation'],
  error: ['border-red-200 bg-red-50 text-red-900 dark:border-red-900 dark:bg-red-950/40 dark:text-red-100', 'fa-circle-exclamation'],
  success: ['border-emerald-200 bg-emerald-50 text-emerald-900 dark:border-emerald-900 dark:bg-emerald-950/40 dark:text-emerald-100', 'fa-circle-check'],
}
const tone = computed(() => tones[props.tone] || tones.info)
</script>

<template>
  <div :class="['flex items-start gap-2 rounded-lg border px-3 py-2 text-sm', tone[0]]" role="status">
    <i :class="['fa-solid mt-0.5', icon || tone[1]]" aria-hidden="true"></i>
    <div class="min-w-0 flex-1"><slot /></div>
    <slot name="action" />
  </div>
</template>
